var exports = {
  "AM": "Popover__8tSDOM",
  "UC": "Content__TNQ3Rh",
  "yE": "Scrollable__s-NIlO",
  "bm": "Close__coAJF4",
  "DZ": "Heading__E3QuaR",
  "VY": "Description__6nE1R6",
  "wi": "Footer__XPdWzU",
  "ph": "Counter__JnGcXI",
  "ib": "Announcement__d9zKEt",
};

module.exports = exports;
